export default __webpack_public_path__ + "static/media/onto-3.c78afd4e.png";